<template>
    <div class="sheetExtra">
        <dsh-icons
            :list="$getOperationList(['copyFieldVal'])"
            @click="$dispatchEvent($event)"
        ></dsh-icons>

        <!-- 列表模态框 -->
        <sheet-select-modal
            v-if="showSheetSelectModal"
            v-model="showSheetSelectModal"
            :multiple="false"
            :useCreate="false"
            :propsObj="propsObj"
            @selectRow="select"
        ></sheet-select-modal>
    </div>
</template>

<script>
    import sheetSelectRenderMixin from "@/mixins/sheet/sheetSelectRenderMixin.js";

    export default {
        name: "sheetExtra",
        mixins: [sheetSelectRenderMixin],
        inject: ["companyId", "appId"],
        props: {
            canEdit: {
                type: Boolean,
                default: true
            },
            formData: {
                type: Object,
                default () {
                    return {};
                }
            },
            formItem: {
                type: Object,
                default () {
                    return {};
                }
            },
            modKey: String
        },
        data () {
            return {
                operationMap: {
                    copyFieldVal: {
                        name: "复制字段值",
                        type: "copyFieldVal",
                        icon: "ios-copy-outline",
                        event: "openSheetSelectModal"
                    }
                }
            };
        },
        computed: {
            propsObj () {
                return {
                    _ref: this.formItem._copyRef,
                    _screen: this.formItem._copyScreen,
                    _refFields: this.formItem._copyShowFields,
                    _key: this.formItem._copyField
                };
            }
        },
        created () {},
        methods: {
            select (data) {
                this.getCopyData(data._id);
            },
            getCopyData (dataId) {
                const fieldKey = this.formItem._key;
                this.$https({
                    url: {
                        module: "sheet",
                        name: "customCopy",
                        params: {
                            modKey: this.modKey
                        }
                    },
                    params: {
                        copyId: dataId,
                        field: fieldKey,
                        [fieldKey]: this.formData[fieldKey]
                    },
                    callback: data => {
                        this.formData[fieldKey] = data[fieldKey];
                        this.change();
                    }
                });
            },

            change () {
                this.$emit("change", this.formItem, this.formData[this.formItem._key], "copy");
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/menu/sheet/attach/sheetExtra.vue